<template>
  <div class="c-text-section section o-section__contact o-section__max-w">
    <h1>Contact Us</h1>

    <div class="t-flex-grid__basic t-flex-grid__basic--contact">
      <div class="c-details">
        <h3>CUSTOMER SERVICE</h3>
        <a href="tel:+64-21-0870-6374">+64 21 0870 6374</a>
        <a href="mailto:sales@artfuldodgers.co.nz">CONTACT@ARTFULDODGERS.CO.NZ</a>
        <br />
        <br />
        <h3>WHOLESALE & RETAILERS</h3>
        <a href="tel:+64-21-0870-6374">+64 21 0870 6374</a>
        <a href="mailto:sales@artfuldodgers.co.nz">SALES@ARTFULDODGERS.CO.NZ</a>
        <a
          class="c-btn c-btn__link c-btn__link--back c-btn__link--contact"
          @click="$router.go(-1)"
        >Go back</a>
      </div>
      <div class="c-form c-form--contact" v-bind:class="{ 'c-form--loading': formLoading }">
        <div class="c-spinner__container" v-bind:class="{ 'c-spinner--visible': formLoading }">
          <div class="c-spinner c-spinner__sphere"></div>
        </div>
        <form id="contactForm" @submit="checkForm()">
          <div
            v-bind:class="{
                            'c-field--invalid': nameError,
                            'c-field--valid': nameValid,
                        }"
            class="c-field c-field--first"
          >
            <label for="name" class="c-field__label">Your name</label>
            <input
              class="c-field__input"
              type="text"
              placeholder="Robert"
              name="name"
              v-model="name"
              required
            />
            <span v-show="nameError" class="c-field__error">Please tell us your name.</span>
          </div>
          <div class="c-field__section">
            <div
              v-bind:class="{
                                'c-field--invalid': contactError || emailError,
                                'c-field--valid': emailValid,
                            }"
              class="c-field"
            >
              <label for="email" class="c-field__label">Email address</label>
              <input
                class="c-field__input"
                type="email"
                placeholder="RDeNiro43@gmail.com"
                v-model="email"
                name="email"
              />
              <span v-show="emailError" class="c-field__error">
                Is that a real email address? We can't verify
                it sorry.
              </span>
            </div>
            <div
              v-bind:class="{
                                'c-field--invalid': contactError || phoneError,
                                'c-field--valid': phoneValid,
                            }"
              class="c-field"
            >
              <label for="phone" class="c-field__label">or phone number</label>
              <input
                class="c-field__input"
                type="phone"
                placeholder="(917) 123-4567"
                v-model="phone"
                name="phone"
              />
              <span v-show="emailError" class="c-field__error">
                Is that a real phone number? We can't verify it
                sorry.
              </span>
            </div>
            <span v-show="contactError" class="c-field__error c-field__error--section">
              We won't be able to get back to you without contact
              details.
            </span>
          </div>
          <div
            v-bind:class="{
                            'c-field--invalid': messageError,
                            'c-field--valid': messageError,
                        }"
            class="c-field c-field--textarea"
          >
            <label for="message" class="c-field__label">Message</label>
            <textarea
              class="c-field__input c-field__input--textarea"
              rows="5"
              placeholder="You talkin' to me?"
              name="content"
              v-model="message"
              required
            ></textarea>
            <span v-show="messageError" class="c-field__error">What's up?</span>
          </div>
          <div class="c-field__section">
            <div class="c-field c-field--checkbox">
              <input
                class="c-field__input--checkbox"
                type="checkbox"
                name="AgreePrivacy"
                id="agreePrivacy"
                v-model="agreePrivacy"
              />
              <label
                for="agreePrivacy"
                class="c-field__label c-field__label--checkbox"
              >Accept privacy policy</label>
              <span
                v-show="agreePrivacyError"
                class="c-field__error c-field__error--captcha"
              >Please accept our privacy policy.</span>
            </div>
            <div
              class="g-recaptcha"
              data-sitekey="6LeFa6kUAAAAAGruS5mADwIa3F417B-7UvrCVcvS"
              data-callback="recaptchaCallback"
            ></div>
          </div>
          <div id="toast" class="c-form__toast"></div>
          <button
            class="c-form__submit c-btn--block"
            v-on:click="checkForm($event)"
            type="submit"
            id="submit"
          >Send</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  metaInfo: {
    title: "Contact",
    meta: [
      {
        name: "description",
        content: "The Artful Dodgers Ltd Ring. Contact",
      },
      { property: "og:title", content: "Contact | Artful Dodgers Ltd" },
      { property: "og:site_name", content: "Artful Dodgers" },
      {
        property: "og:description",
        content: "The Artful Dodgers Ltd. Treat yourself!",
      },
      { property: "og:type", content: "contact" },
      {
        property: "og:url",
        content: "https://artfuldodgers.co.nz/contact",
      },
      {
        property: "og:image",
        content: "https://artfuldodgers.co.nz/assets/img/ad-trixy-ring.png",
      },
    ],
  },
  data: function () {
    return {
      captchaYaya: false,
      formLoading: false,
      name: null,
      email: null,
      message: null,
      phone: null,
      agreePrivacy: false,
      agreePrivacyError: false,
      nameError: false,
      emailError: false,
      phoneError: false,
      messageError: false,
      contactError: false,
      nameValid: false,
      emailValid: false,
      messageValid: false,
      phoneValid: false,
    };
  },
  methods: {
    loadRecaptcha: function () {
      let script = document.createElement("script");
      script.setAttribute("async", "");
      script.setAttribute("defer", "");
      script.id = "recaptchaScript";
      script.src = "https://www.google.com/recaptcha/api.js";
      document.getElementsByTagName("head")[0].appendChild(script);
    },
    checkForm: function (e) {
      if (
        this.name &&
        (this.email || this.phone) &&
        this.message &&
        this.agreePrivacy &&
        this.captchaYaya
      ) {
        return true;
      }
      if (!this.agreePrivacy) {
        this.agreePrivacyError = true;
      }
      if (!this.name) {
        this.nameError = true;
      }
      if (!this.phone && !this.email) {
        this.contactError = true;
      } else if (!this.phone) {
        if (this.validEmail(this.email)) {
          this.emailError = true;
        }
      }
      if (!this.message) {
        this.messageError = true;
      }

      e.preventDefault();
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
  },
  watch: {
    name: function (newVal, oldVal) {
      if (newVal.length > 2) {
        this.nameValid = true;
        this.nameError = false;
      }
    },
    email: function (newVal, oldVal) {
      if (this.validEmail(newVal)) {
        this.emailValid = true;
        this.emailError = false;
        this.contactError = false;
      }
    },
    phone: function (newVal, oldVal) {
      if (newVal.length > 5) {
        this.phoneValid = true;
        this.phoneError = false;
        this.contactError = false;
      }
    },
    message: function (newVal, oldVal) {
      if (newVal.length > 2) {
        this.messageValid = true;
        this.messageError = false;
      }
    },
    agreePrivacy: function (newVal, oldVal) {
      if (newVal) {
        this.agreePrivacyError = false;
      }
    },
  },
  mounted: function () {
    this.loadRecaptcha();
    const form = document.getElementById("contactForm");
    const url =
      "https://5nvshjds5f.execute-api.us-west-2.amazonaws.com/dev/email/send";
    const toast = document.getElementById("toast");
    const submit = document.getElementById("submit");
    var self = this;

    function post(url, body, callback) {
      var req = new XMLHttpRequest();
      req.open("POST", url, true);
      req.setRequestHeader("Content-Type", "application/json");
      req.addEventListener("load", function () {
        if (req.status < 400) {
          callback(null, JSON.parse(req.responseText));
        } else {
          callback(new Error("Request failed: " + req.statusText));
        }
      });
      req.send(JSON.stringify(body));
    }
    function success() {
      toast.innerHTML =
        "Thanks for sending us a message! We'll get in touch with you ASAP. :)";
      self.formLoading = false;
      submit.disabled = false;
      submit.blur();
      form.name.focus();
      form.name.value = "";
      form.email.value = "";
      form.content.value = "";
    }
    function error(err) {
      toast.innerHTML =
        "There was an error with sending your message, hold up until we fix it. Thanks for waiting.";
      self.formLoading = false;
      submit.disabled = false;
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      self.formLoading = true;
      submit.disabled = true;

      const payload = {
        name: form.name.value,
        email: form.email.value,
        content: form.content.value,
      };
      post(url, payload, function (err, res) {
        if (err) {
          return error(err);
        }
        success();
      });
    });

    window.recaptchaCallback = function () {
      self.captchaYaya = true;
    };
  },
  beforeDestroy() {
    document.getElementById("recaptchaScript").remove();
  },
};
</script>



// WEBPACK FOOTER //
// Contact.vue?318b2604